/* eslint-disable */
import Product from '@/pages/adminCenter/page/product/index';
const ProductRouter = [{
  path: 'product',
  component: Product,
}]
export default [...ProductRouter]



// WEBPACK FOOTER //
// ./src/router/admin/product.js